// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
  margin: 0;
  padding: 0;
  width: 100vw;
  height: 100vh;
}

body{
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  font-family: Ubuntu, mono;
  color: #262A53;
}

#root {
  width: inherit;
  height: inherit;
  font-size: 14px;
  background-color: #B4CBEF;
}

.title{
  font-weight: bold;
  font-size: 2.4em;
}

span{
  font-size: 1.2em;
  margin: 3% 0%;
  user-select: none;
}
`, "",{"version":3,"sources":["webpack://./src/Common.module.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,iBAAiB;AACnB","sourcesContent":[":global(html) {\n  margin: 0;\n  padding: 0;\n  width: 100vw;\n  height: 100vh;\n}\n\n:global(body){\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  height: 100%;\n  font-family: Ubuntu, mono;\n  color: #262A53;\n}\n\n:global(#root) {\n  width: inherit;\n  height: inherit;\n  font-size: 14px;\n  background-color: #B4CBEF;\n}\n\n:global(.title){\n  font-weight: bold;\n  font-size: 2.4em;\n}\n\n:global(span){\n  font-size: 1.2em;\n  margin: 3% 0%;\n  user-select: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
